import { FormApi } from 'final-form';

import { OnChange } from '@occc-app/design-system';
import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

import { SweepstakesConfigureFormValues, SweepstakesType } from '../types';

type SweepstakesFormValuesWatcherProps = {
  values: SweepstakesConfigureFormValues;
  form: FormApi<SweepstakesConfigureFormValues>;
};

const clearMinimumPurchaseConstraint = (form: FormApi<SweepstakesConfigureFormValues>) => {
  form.mutators.setFieldValue('minimumPurchaseConstraints.isEnabled', false);
  form.mutators.setFieldValue('minimumPurchaseConstraints.items', [
    { countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute.Quantity },
  ]);
};

export const SweepstakesFormValuesWatcher = ({
  values,
  form,
}: SweepstakesFormValuesWatcherProps) => {
  return (
    <>
      <OnChange name='sweepstakesType'>
        {(newSweepstakesType: SweepstakesType) => {
          if (
            newSweepstakesType !== SweepstakesType.VarietyChallenge ||
            values.productChallenge?.earningMechanism !== 'varietyPurchase'
          ) {
            clearMinimumPurchaseConstraint(form);
          }
        }}
      </OnChange>
      <OnChange name='productChallenge.earningMechanism'>
        {(earningMechanism: string) => {
          if (
            values.sweepstakesType !== SweepstakesType.VarietyChallenge ||
            earningMechanism !== 'varietyPurchase'
          ) {
            clearMinimumPurchaseConstraint(form);
          }
        }}
      </OnChange>
    </>
  );
};
